import { createContext } from "react";
import { useParams } from "react-router-dom";
import useSignFormLogic from "./hooks/useSignFormLogic";
import Loader2 from "../../../../components/Loader2";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import DocumentHeader from "./components/DocumentHeader";
import FormTemplateSelection from "./components/FormTemplateSelection";
import PdfTemplateDisplay from "./components/PdfTemplateDisplay";
import Signature from "../../CommonComponents/Signature/Signature";

export const SignFormContext = createContext(null)

export default function SignForm() {
    const { id } = useParams();
    const context = useSignFormLogic(id);
    const {
        studentDataArray,
        batchData,
        pdfTemplateData,
        isLoadingResources,
        handleSubmit,
        loadSignatures,
        pdfUrl
    } = context ?? {}

    if (!id) return <h1 className="text-danger">Invalid page redirect</h1>

    if (isLoadingResources) return <Loader2 />

    return (
        <SignFormContext.Provider value={context}>
            <Container fluid>
                <DocumentHeader />
                <Row>
                    <Col md="4">
                        <FormTemplateSelection/>
                    </Col>
                    <Col md="8">
                        <PdfTemplateDisplay />
                    </Col>
                </Row>
            </Container>
        </SignFormContext.Provider>
    )
}